import APIService from "@/services/APIService.js"; 

export default {
  getAllNormasTecnicas() {
    return APIService.apiCall().get("/normasTecnicas/getAllNormasTecnicas");
  },
  getNormasTecnicas(id) {
    return APIService.apiCall().get(`/normasTecnicas/getNormasTecnicas/${id}`);
  },
  getValoresPadroes() {
    return APIService.apiCall().get(`/normasTecnicas/getValoresPadroes`);
  },
  getArquivoPadrao() {
    return APIService.apiCall().get(`/normasTecnicas/getArquivoPadrao/`, { responseType: "blob" });
  },
  salvarNormasTecnicas(postData, id) {
    return APIService.apiCall().post(`/normasTecnicas/salvar/${id}`, JSON.stringify(postData));
  },
  deletar(id) {
    return APIService.apiCall().get(`/normasTecnicas/excluir/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/normasTecnicas/baixar/${id}`, { responseType: "blob", ...config });
  },
  getJsonValores(postData) {
    return APIService.apiCall().post(`/normasTecnicas/getJsonFromFile`, JSON.stringify(postData));
  }
};